module.exports = "/*\r\n.selectedIndex {\r\n    background:#EDE7F6;\r\n} \r\n*/\r\n.selectedIndex .mat-icon  {\r\n  color: #fff;\r\n  background: #673ab7;\r\n}\r\n/* \r\n.selectedIndex.mat-icon  {\r\n  color: #fff;\r\n}\r\n\r\n.selectedIndex  {\r\n  background: #673ab7;\r\n  color: #fff;\r\n} \r\n\r\n*/"


//////////////////
// WEBPACK FOOTER
// ./src/app/cloud-folder-content/cloud-folder-content.component.css
// module id = ./src/app/cloud-folder-content/cloud-folder-content.component.css
// module chunks = main